import React from 'react'
import PropTypes from 'prop-types'
import * as Types from 'types'
import {
  fieldPropTypesWithValue,
  omitLabelProps,
  LabeledField,
} from 'lp-components'
import { CloudinaryFileInput } from 'components'
import {
  convertCloudinarySrcUrlToFilename,
  getCloudinaryUploadErrorMessage,
} from 'utils'
import { get, noop } from 'lodash'

const propTypes = {
  ...fieldPropTypesWithValue(Types.attachmentUpload),
  flashSuccessMessage: PropTypes.func.isRequired,
  flashErrorMessage: PropTypes.func.isRequired,
}

const defaultProps = {}

function SingleAttachmentInput(props) {
  const {
    input: { value: attachment, onChange, name },
    className, //eslint-disable-line no-unused-vars
    flashSuccessMessage,
    flashErrorMessage,
    ...rest
  } = omitLabelProps(props)

  const handleSuccess = ({ secureUrl }) => {
    const filename = convertCloudinarySrcUrlToFilename(secureUrl)
    flashSuccessMessage('Attachment successfully uploaded')
    return onChange({ src: secureUrl, filename })
  }

  const handleFailure = (err) => {
    const message = getCloudinaryUploadErrorMessage(err)
    flashErrorMessage(message)
  }

  return (
    <LabeledField {...props}>
      <CloudinaryFileInput
        {...{
          id: name,
          onUploadSuccess: handleSuccess,
          onUploadFailure: handleFailure,
          attachment,
          input: {
            name,
            value: get(attachment, 'src', ''),
            onChange: noop, // use onUploadSuccess/Failure instead
          },
          label: false, // use label created by Redux Field
          ...rest,
        }}
      />
    </LabeledField>
  )
}

SingleAttachmentInput.propTypes = propTypes
SingleAttachmentInput.defaultProps = defaultProps

export default SingleAttachmentInput
